import styledTheme from 'common/theme';
import { Button } from 'components';
import styled from 'styled-components';
import { IconTextBtn } from 'components/RibbonComponent';
import breakpoints from 'constants/breakpoints';

const svgMarkup = `<svg width="1140" height="244" viewBox="0 0 1140 244" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.25" clip-path="url(#clip0_3176_92122)">
<path opacity="0.35" d="M817.751 251.312C814.383 248.799 811.014 246.339 807.686 243.861C727.999 185.813 632.104 155.882 537.003 159.257C446.854 162.507 360.074 196.424 285.261 251.276H817.751V251.312Z" fill="#008200"/>
<path opacity="0.35" d="M1157.99 204.391C1069.89 136.588 966.353 64.3155 847.997 81.5911C764.478 93.7731 709.52 160.952 636.036 193.669C540.579 236.128 465.757 181.897 380.334 145.422C265.065 96.2665 122.677 109.642 19.9131 179.261C-11.8888 200.829 -42.3012 227.989 -73.9487 251.088H1157.99V204.391Z" fill="#008200"/>
<path opacity="0.35" d="M1477.59 162.077C1468.33 160.806 1459.17 160.609 1450.9 161.325C1419.63 163.922 1389.98 177.118 1361.15 190.797C1332.32 204.477 1303.36 218.891 1272.39 224.334C1169.07 242.454 1083.6 161.128 988.162 134.915C901.672 111.173 810.042 131.692 726.079 164.53C640.617 197.924 552.371 244.818 463.525 224.853C400.981 210.798 348.633 165.3 290.845 135.399C188.419 82.3273 79.6535 83.5091 -26.3706 109.185V251.031H1477.59V162.077Z" fill="#008200"/>
</g>
<defs>
<clipPath id="clip0_3176_92122">
<rect width="1140" height="244" fill="white"/>
</clipPath>
</defs>
</svg>
`;

// Encode the SVG string
const encodedSvg = encodeURIComponent(svgMarkup);

const CartWrapper = styled.div`
  overflow: auto;
  height: calc(90vh - 22rem);
`;
const CartWizardContainer = styled.div`
  height: 90vh;
  overflow: auto;
`;
const CartDownloadBtn = styled.div`
  display: flex;
  margin: 0rem 2rem;
  gap: 1.5rem;
  padding: 0.5rem;
  border-bottom: 0.0625rem solid ${styledTheme.colors.lightGrey6};
`;
const BannerBox = styled.div`
  margin: 1rem 2rem 0.3rem;
`;
const CartListWrapper = styled.div`
  height: 100%;
  position: relative;
`;
const SelectionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  .heading {
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: ${styledTheme.colors.gray800};
  }
  h3 {
    font-size: 1rem;
  }
  .card-description {
    margin: 0;
    color: ${styledTheme.colors.gray800};
  }
  .icon {
    height: 10rem;
  }
`;
const CardContainer = styled.div`
  display: flex;
  gap: 3rem;
  @media (max-width: ${breakpoints.size.lg}px) {
    gap: 1rem;
  }
`;
const CardContent = styled.label`
  height: 100%;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  padding: 1.75rem;
  cursor: pointer;
  .checkbox {
    align-self: start;
  }
  &.disabled {
    cursor: not-allowed;
  }
`;
const Container = styled.div`
  height: 100%;
  position: relative;
`;
const CartSuccessPageContainer = styled.div`
  display: flex;
  height: 70%;
  justify-content: space-evenly;
  align-items: center;
  .icon--check-success {
    width: 140px;
    height: 140px;
    margin-bottom: 1rem;
  }
`;
const DownloadCartOrder = styled(Button)`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const Divider = styled.div`
  width: 1px;
  height: 22rem;
  background: ${styledTheme.colors.gray400};
`;
const CartSuccessPageFooter = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 350px;
`;

const BgContainer = styled.div<{ bg?: string }>`
  position: relative;
  width: 100%;
  &:after {
    content: '';
    position: absolute;
    background-image: url('data:image/svg+xml,${encodedSvg}');
    background-position: center;
    fill: fill;
    width: 100%;
    height: 275px;
    top: 0;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;
const FooterBtn = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  button {
    padding: 0.4rem 3rem;
  }
`;

const ClearCartBtn = styled(IconTextBtn)`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  .icon--clear-cart {
    margin-bottom: 0.2rem;
  }
  .delete-cart-btn {
    line-height: 1;
  }
`;
const TentativeDate = styled.div`
  width: 10.5rem;
`;
const DownloadWrapper = styled.div``;
export {
  CartWrapper,
  CartWizardContainer,
  CartDownloadBtn,
  BannerBox,
  CartListWrapper,
  SelectionContainer,
  CardContainer,
  CardContent,
  CartSuccessPageContainer,
  DownloadCartOrder,
  Container,
  CartSuccessPageFooter,
  BgContainer,
  FooterBtn,
  DownloadWrapper,
  ClearCartBtn,
  Divider,
  TentativeDate
};
